import React, { useState, useEffect } from "react";
// import axios from "axios";
import {
  MainWrapper,
  LeftSection,
  RightSection,
  LoginContainer,
  Heading,
  FormSection,
  InputField,
  CustomInput,
  LoginButton,
  ErrorText,
  NewAccountSection,
  SignUpSpan,
} from "./index.styled";
import { signUpUser } from "../../Redux/auth/auth.actions";
import { useDispatch } from "react-redux";
import { ReactComponent as HideIcon } from "../../Assets/Icons/HideIcon.svg";
import { ReactComponent as ShowIcon } from "../../Assets/Icons/ShowIcon.svg";
import { ReactComponent as CheckCircle } from "../../Assets/Icons/icon-park-solid_check-one.svg";
import { ReactComponent as ConfirmCircle } from "../../Assets/Icons/icon-park-solid_check-one-green.svg";
import { ReactComponent as ErrorInfo } from "../../Assets/Icons/ErrorInfo.svg";
import { ReactComponent as BigCircle } from "../../Assets/Icons/BigCircle.svg";
import { ReactComponent as MidCircle } from "../../Assets/Icons/MidCircle.svg";
import { ReactComponent as SmallCircle } from "../../Assets/Icons/SmallCircle.svg";
import Dashboard from "../../Assets/Images/Dashboard.png";
import { useNavigate } from "react-router-dom";
import { Loader } from "../../App";
import { useSnack } from "../../Components/SnackBar";
import { viewSizeCalculator } from "../../utils";

const SignUp = () => {
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const snack = useSnack();

  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const passwordChecks = {
    length: formData.password.length >= 8,
    uppercase: /[A-Z]/.test(formData.password),
    number: /[0-9]/.test(formData.password),
    special: /[!@#$%^&*(),.?":{}|<>]/.test(formData.password),
  };

  const handleChange = (field) => (e) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) return;

    const newErrors = {};
    if (!formData.username) newErrors.username = "Username is required";
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.password) newErrors.password = "Password is required";
    if (formData.password !== formData.confirmPassword)
      newErrors.confirmPassword = "Passwords do not match";

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      setIsLoading(true);

      try {
        const { username, email, password } = formData;

        // call API directly to catch 409 Conflict
        const response = await dispatch(
          signUpUser({ username, email, password }),
        );

        if (response.success) {
          snack(
            "Sign-up successful! Redirecting to login...",
            "#4BB543",
            "#FFFFFF"
          );

          setTimeout(() => {
            navigate("/sign-in");
          }, 2000);
        } else {
          throw new Error(response.message || "Signup failed");
        }
      } catch (error) {
        let message = "Something went wrong";
        console.log(error);
        if (error?.response?.status === 409) {
          const serverMsg = error?.response?.data?.message;
          if (serverMsg?.includes("username"))
            message = "Username already exists";
          else if (serverMsg?.includes("email"))
            message = "Email already exists";
          else message = "Username or Email already exists";
        } else if (error.message?.includes("409")) {
          message = "Username or Email already exists";
        } else {
          message = error.message || "Sign-up failed";
        }

        snack(message,"#F34D4D", "#FFFFFF");

      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleLogIn = () => {
    navigate("/sign-in");
  };

  const isFormFilled = () => {
    const { username, email, password, confirmPassword } = formData;
    const allFieldsFilled =
      username && email && password && confirmPassword ? false : true;
    return allFieldsFilled;
  };

  return (
    <MainWrapper>
      <LeftSection>
        <LoginContainer>
          <Heading>Let’s Build Your Profile!</Heading>
          <FormSection as="form" onSubmit={handleSubmit}>
            {/* Username */}
            <div>
              <InputField error={errors.username}>
                <CustomInput
                  type="text"
                  placeholder="Enter Username ⃰"
                  value={formData.username}
                  onChange={handleChange("username")}
                />
              </InputField>
              {errors.username && (
                <ErrorText>
                  <ErrorInfo
                    width={viewSizeCalculator(1)}
                    height={viewSizeCalculator(1)}
                  />
                  {errors.username}
                </ErrorText>
              )}
            </div>
            {/* Email */}
            <div>
              <InputField error={errors.email}>
                <CustomInput
                  type="email"
                  placeholder="Enter Email ID ⃰"
                  value={formData.email}
                  onChange={handleChange("email")}  
                />
              </InputField>
              {errors.email && (
                <ErrorText>
                  <ErrorInfo
                    width={viewSizeCalculator(1)}
                    height={viewSizeCalculator(1)}
                  />
                  {errors.email}
                </ErrorText>
              )}
            </div>
            {/* Password */}
            <div>
              <InputField error={errors.password}>
                <CustomInput
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter Password ⃰"
                  value={formData.password}
                  onChange={handleChange("password")}
                />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: `${viewSizeCalculator(0.5)}`,
                  }}
                >
                  {formData?.password?.length > 0 &&
                    !Object.values(passwordChecks).every(Boolean) && (
                      <ErrorInfo
                        fill="red"
                        width={viewSizeCalculator(1.25)}
                        height={viewSizeCalculator(1.25)}
                      />
                    )}
                  <div
                    onClick={() => setShowPassword((prev) => !prev)}
                    style={{ cursor: "pointer" }}
                  >
                    {showPassword ? (
                      <ShowIcon
                        width={viewSizeCalculator(1.25)}
                        height={viewSizeCalculator(1)}
                      />
                    ) : (
                      <HideIcon
                        width={viewSizeCalculator(1.25)}
                        height={viewSizeCalculator(1.0625)}
                      />
                    )}
                  </div>
                </div>
              </InputField>
              {formData?.password?.length > 0 &&
                Object.values(passwordChecks).includes(false) && (
                  <ErrorText>
                    <ErrorInfo
                      width={viewSizeCalculator(1)}
                      height={viewSizeCalculator(1)}
                    />
                    Please ensure all password requirements are met
                  </ErrorText>
                )}
            </div>
            <PasswordChecklist checks={passwordChecks} />
            {/* Confirm Password */}
            <div>
              <InputField error={errors.confirmPassword}>
                <CustomInput
                  type="password"
                  placeholder="Confirm Password ⃰"
                  value={formData.confirmPassword}
                  onChange={handleChange("confirmPassword")}
                />
              </InputField>

              {errors.confirmPassword && (
                <ErrorText>
                  <ErrorInfo
                    width={viewSizeCalculator(1)}
                    height={viewSizeCalculator(1)}
                  />
                  {errors.confirmPassword}
                </ErrorText>
              )}
            </div>
            {/* Submit Button */}
            <LoginButton type="submit" disabled={isFormFilled()}>
              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: `${viewSizeCalculator(0.5)}`,
                  }}
                >
                  <Loader
                    width={viewSizeCalculator(1)}
                    height={viewSizeCalculator(1)}
                    border={`${viewSizeCalculator(0.125)} solid #fff`}
                  />
                  Signing Up...
                </div>
              ) : (
                "Sign Up"
              )}
            </LoginButton>

            {/* Link to Login */}
            <NewAccountSection>
              Already have an account?
              <SignUpSpan onClick={handleLogIn}>Log In</SignUpSpan>
            </NewAccountSection>
          </FormSection>
        </LoginContainer>
      </LeftSection>

      <RightSection>
        <img
          src={Dashboard}
          alt="dashboard"
          style={{
            height: viewSizeCalculator(38),
            position: "absolute",
            right: "0",
            zIndex: 100,
          }}
        />
        <SmallCircle
          style={{
            position: "absolute",
            zIndex: 99,
            right: "-1%",
            width: viewSizeCalculator(39),
            height: viewSizeCalculator(39.125),
          }}
        />
        <MidCircle
          style={{
            position: "absolute",
            zIndex: 99,
            right: "-10%",
            width: viewSizeCalculator(48.375),
            height: viewSizeCalculator(48.0625),
          }}
        />
        <BigCircle
          style={{
            position: "absolute",
            zIndex: 99,
            right: "-22%",
            width: viewSizeCalculator(60.4375),
            height: viewSizeCalculator(57.9375),
          }}
        />
      </RightSection>
    </MainWrapper>
  );
};

const PasswordChecklist = ({ checks }) => {
  const checklistStyle = {
    display: "flex",
    alignItems: "center",
    gap: `${viewSizeCalculator(0.5)}`,
    fontSize: `${viewSizeCalculator(0.75)}`,
    marginBottom: `${viewSizeCalculator(0.25)}`,
    color: "#333",
  };

  const renderIcon = (condition) =>
    condition ? (
      <ConfirmCircle
        fill="green"
        width={viewSizeCalculator(1)}
        height={viewSizeCalculator(1)}
      />
    ) : (
      <CheckCircle
        fill="gray"
        width={viewSizeCalculator(1)}
        height={viewSizeCalculator(1)}
      />
    );

  return (
    <div style={{ marginTop: () => `${viewSizeCalculator(0.5)}` }}>
      <div style={checklistStyle}>
        {renderIcon(checks.length)} Minimum 8 characters
      </div>
      <div style={checklistStyle}>
        {renderIcon(checks.uppercase)} At least 1 uppercase letter
      </div>
      <div style={checklistStyle}>
        {renderIcon(checks.number)} At least 1 number
      </div>
      <div style={checklistStyle}>
        {renderIcon(checks.special)} At least 1 special character (e.g., @, #,
        !)
      </div>
    </div>
  );
};

export default SignUp;
